import { authFetch } from "./Auth";
import { DateTime } from "luxon";
export function urlQuery(params) {
    return Object.keys(params).map((key) => {
        return encodeURIComponent(key) + '=' + encodeURIComponent(params[key]);
    }).join('&');
}
export async function getTagSuggestions(query) {
    let response = await authFetch('/tags/list', {
        method: 'POST',
        body: JSON.stringify({
            value: query
        })
    });
    if (response.ok) {
        return await response.json();
    }
    else {
        alert(response.statusText);
    }
}
export async function createTag(tag) {
    tag.fgStyle = "";
    tag.bgStyle = "secondary";
    let response = await authFetch('/tags/create', {
        method: 'POST',
        body: JSON.stringify(tag),
    });
    if (response.ok) {
        tag.id = (await response.json()).id;
    }
    else {
        alert(response.statusText);
    }
}
export async function addUser(phone, telegram_id, username, name) {
    return await addUsers([{ telegram_id, phone, username, name }], false);
}
export async function addUsers(users, onlyCheckTelegram = false) {
    let response = await authFetch('/users/add', {
        method: 'POST',
        body: JSON.stringify({
            'users': users,
            'onlyCheckTelegram': onlyCheckTelegram
        })
    });
    if (response.ok) {
        return (await response.json());
    }
    else {
        alert(response.statusText);
        return null;
    }
}
export async function addSearchNearTask(square) {
    let response = await authFetch('/search-near/add-task', {
        method: 'POST',
        body: JSON.stringify({
            'square': square
        })
    });
    if (response.ok) {
        return (await response.json());
    }
    else {
        alert(response.statusText);
        return null;
    }
}
export var View;
(function (View) {
    View["full"] = "full";
    View["compact"] = "compact";
})(View || (View = {}));
export var MessageStatus;
(function (MessageStatus) {
    MessageStatus["success"] = "\u0423\u0441\u043F\u0456\u0445";
    MessageStatus["failed"] = "\u041F\u043E\u043C\u0438\u043B\u043A\u0430";
    MessageStatus["pending"] = "\u0412 \u0447\u0435\u0440\u0437\u0456";
})(MessageStatus || (MessageStatus = {}));
export var UserType;
(function (UserType) {
    UserType["bot"] = "\u0411\u043E\u0442";
    UserType["deleted"] = "\u0412\u0438\u0434\u0430\u043B\u0435\u043D\u0438\u0439";
    UserType["regular"] = "\u0417\u0432\u0438\u0447\u0430\u0439\u043D\u0438\u0439";
    UserType["unknown"] = "\u041D\u0435\u0432\u0456\u0434\u043E\u043C\u043E";
})(UserType || (UserType = {}));
export var UserStatus;
(function (UserStatus) {
    UserStatus["lastMonth"] = "\u041C\u0456\u0441\u044F\u0446\u044C \u0442\u043E\u043C\u0443";
    UserStatus["lastWeek"] = "\u0422\u0438\u0436\u0434\u0435\u043D\u044C \u0442\u043E\u043C\u0443";
    UserStatus["offline"] = "\u041E\u0444\u043B\u0430\u0439\u043D";
    UserStatus["online"] = "\u041E\u043D\u043B\u0430\u0439\u043D";
    UserStatus["recently"] = "\u041D\u0435\u0434\u0430\u0432\u043D\u043E";
})(UserStatus || (UserStatus = {}));
export function strToLocaleDateTime(dateTime) {
    if (dateTime == null || dateTime.length < 1) {
        return '';
    }
    return DateTime.fromISO(dateTime).setLocale('ru').toFormat("MM-dd HH:mm");
}
export function strToFullLocaleDateTime(dateTime) {
    if (dateTime == null || dateTime.length < 1) {
        return '';
    }
    return DateTime.fromISO(dateTime).setLocale('ru').toFormat("YYYY-MM-dd HH:mm");
}
